import React from 'react';
import Login from '../../components/templates/Login';

/**
 * ログイン画面
 */
class LoginApp extends React.Component {
  async componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return <Login />;
  }
}
export default LoginApp;
